/* eslint-disable func-names */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import $ from 'jquery';
import './StreamOverlayDrawerHeader.scss';
import Tooltip from '@mui/material/Tooltip';
import {
  soArrowUP, soTableIcon, soTableColor, soSettingIcon, soSettingColor, soArrDockUndock
} from '../../shared/assets/images';

import { getStreamDataProp } from '../userData';
import StreamOverlayTableView from './StreamOverlayTableView';
import StreamOverlaySetting from './StreamOverlaySetting';

const StreamOverlayDrawerHeader = (props) => {
  const { fileName } = props;
  // To-Do: setting one
  const reqPropArDefault = getStreamDataProp();
  const { t } = useTranslation();
  const translateObject = t;
  const [reqPropAr, setReqPropAr] = useState([...reqPropArDefault]);
  const [overlayDisplay, setOverlayDisplay] = useState({ tableView: true, settingView: false });
  const [dockUndockTxt, setDockUndockTxt] = useState('Undock');
  const [openSoTable, setOpenSoTable] = useState(false); // for Stream Overlay table & setting comp.
  // when user click on arrow this function will get called and set the streamNum_dict
  const saveStreamNum_dict = () => {
    const obj = {};
    document.querySelectorAll('.react-flow__viewport .react-flow__edgelabel-renderer input').forEach((ele) => {
      obj[ele.value] = Number(ele.value);
    });
    localStorage.setItem('streamNum_dict', JSON.stringify(obj));
  };

  const handleSOArrDown = () => {
    saveStreamNum_dict();
    $('.strOvlyHead').toggleClass('strOvlyHeadToggle');

    // when this will true then only we are rendering the tableView & setting view
    setOpenSoTable(!openSoTable);  // toggle state only when user click on Arrow icon

    // ToDo : Remove
    $('.strOvlyHead').removeClass('strOvlyHeadToggleunDock');
    $('.soContainer').removeClass('soContainerToggle');
    $('.MuiTableContainer-root').removeClass('MuiTableContainer-root-toggle');
    $('.propsContainers').removeClass('propsContainersToggle');
    $('.tsText').removeClass('tsText-toggle ');
    $('#updateSetingBtn').removeClass('updateSetingBtn-Toggle');
    $('#resetSetting').removeClass('resetSettingBtn-Toggle');

  };

  const handleTableView = () => {
    setOverlayDisplay({ tableView: true, settingView: false });
    $('.setingImg').attr('src', soSettingIcon);
    $('.tableImg').attr('src', soTableColor);

    $('#settingView').hide();
    $('#tableView').show();
  };

  const handleSetting = () => {
    setOverlayDisplay({ tableView: false, settingView: true });
    $('.tableImg').attr('src', soTableIcon);
    $('.setingImg').attr('src', soSettingColor);

    $('#tableView').hide();
    $('#settingView').show();
  };

  // to change img of undocking
  $('#dockUndock').click(function (event) {
    event.preventDefault();
    $('img:visible', this).hide().siblings().show();
  });

  const handleDockUndock = () => {
    $('.strOvlyHead').toggleClass('strOvlyHeadToggleunDock');
    $('.soContainer').toggleClass('soContainerToggle');
    $('.MuiTableContainer-root').toggleClass('MuiTableContainer-root-toggle');
    $('.propsContainers').toggleClass('propsContainersToggle');
    $('.tsText').toggleClass('tsText-toggle ');
    $('#updateSetingBtn').toggleClass('updateSetingBtn-Toggle');
    $('#resetSetting').toggleClass('resetSettingBtn-Toggle');
    // Tooltip
    if (dockUndockTxt === 'Undock') setDockUndockTxt('Dock');
    else setDockUndockTxt('Undock');
  };

  useEffect(() => {
    $('.tableImg').attr('src', soTableColor);
    if (overlayDisplay.tableView) {
      $('#settingView').hide();
      $('#tableView').show();
    } else {
      $('#tableView').hide();
      $('#settingView').show();
    }
  }, []);

  return (
    <div className='streamOverlayDrawerHeader'>
      <div id='soHeader' className='strOvlyHead'>
        <div style={{ 'textAlign': 'center' }}>
          <span className='QRtext'>{translateObject('Quick Results')}</span>
          <span className='sobtncont' >
            {openSoTable && <span id='soHeaderBtnsCont' className='hideMe_'>
              <Tooltip title='Table' placement='top' arrow>
                <span className='pad-right' onClick={handleTableView}>
                  <img className='tableImg' src={soTableIcon} alt="soTableIcon" />
                </span>
              </Tooltip>
              <Tooltip title='Setting' placement='top' arrow>
                <span className='pad-right' onClick={handleSetting}>
                  <img className='setingImg' src={soSettingIcon} alt="soSettingIcon" />
                </span>
              </Tooltip>
              <Tooltip title={dockUndockTxt} placement='top' arrow>
                <span className='pad-right m-3' id='dockUndock' onClick={handleDockUndock} style={{ margin: '3px 0 0 0 !important' }}>
                  <img className='unDockImg' src={soArrDockUndock} alt="soUndockIcon" />
                  <img className='dockImg' src={soArrDockUndock} alt="soDockIcon" style={{ 'display': 'none' }} />
                </span>
              </Tooltip>
            </span>}
            <span className='pad-right m-3' onClick={handleSOArrDown} style={{ margin: '3px 0 0 0 !important' }}>
              <img className='updownArrow' src={soArrowUP} alt="soArrowUP" />
            </span>
          </span>
        </div>
      </div>
      {openSoTable && <div id='soContainer' className='soContainer hideMe_'>
        <StreamOverlayTableView fileName={fileName} reqPropAr={reqPropAr} />
        <StreamOverlaySetting setReqPropAr={setReqPropAr} setOverlayDisplay={setOverlayDisplay} />
      </div>}
    </div>
  );
};

export default StreamOverlayDrawerHeader;